export interface Analysis {
  id: (typeof ANALYSIS_IDS)[keyof typeof ANALYSIS_IDS];
  type: string;
  name: string;
  title: string;
  flagCount: number;
  description: string;
  metrics: any[];
}

export const ANALYSIS_IDS = {
  LEXICAL: 'lexical-analysis',
  SYNTACTIC: 'syntactic-analysis',
  STRUCTURAL: 'structural-analysis',
  READABILITY: 'readability-analysis'
} as const;
